import SignInForm from '../../components/auth/SignInForm';
import DealerAuthHero from '../../components/dealer/DealerAuthHero';
import type { PortalClient } from '../../hooks/useAuth';

interface DealerLoginPageProps {
  auth: {
    loginByUsername: (username: string, password: string, rememberMe?: boolean, client?: PortalClient) => Promise<void>;
  };
}

/**
 * Spec 085 (§1, G16, BR-2) — the dealer portal login at `/dealer/login`: the partner sign-in form in its dealer
 * variant (username + password like garage partners, no self-signup), sent to `/api/auth/login/username` with
 * `X-Garagat-Client: dealer-portal` so identity refuses non-dealer accounts with 403 WRONG_APP. Dealer users
 * created before usernames sign in with their email in the same field (it is their username).
 */
function DealerLoginPage({ auth }: DealerLoginPageProps) {
  const handleSignIn = async (username: string, password: string, rememberMe: boolean) => {
    await auth.loginByUsername(username, password, rememberMe, 'dealer-portal');
  };

  return (
    <div className="dealer-auth">
      <DealerAuthHero />
      <main className="auth-split-form">
        <div className="auth-split-form-inner">
          <SignInForm variant="dealer" onSubmit={handleSignIn} />
        </div>
      </main>
    </div>
  );
}

export default DealerLoginPage;
